import arrowGreenUpIcon from '../../../images/icons/icon-arrow-green-up.svg';
import arrowOrangeUpIcon from '../../../images/icons/icon-arrow-orange-up.svg';
import checkMarkIcon from '../../../images/icons/icon-checkmark.svg';
import arrowOrangeDownIcon from '../../../images/icons/icon-arrow-orange-down.svg';
import arrowRedDownIcon from '../../../images/icons/icon-arrow-red-down.svg';

const base = {
  clicks: {
    label: 'Clicks',
    name: 'clicks',
    selected: true,
  },
  pacing_towards: {
    label: 'Pacing Towards',
    name: 'pacing_towards',
    type: 'currency',
    selected: true,
  },
  average_roi: {
    label: 'ROI',
    name: 'average_roi',
    type: 'roi',
    selected: true,
  },
  short_name: {
    label: 'Merchants',
    name: 'short_name',
    type: 'string',
    selected: true,
  },
  // TODO: Remove this once budget overhaul project is rolled out with no risk of revert
  // 'daily_budget_amount': {
  // 	label: 'Daily Budget', name: 'daily_budget_amount', type: 'currency', selected: true,
  // },
  monthly_budget_amount: {
    label: 'Monthly Budget',
    name: 'monthly_budget_amount',
    type: 'currency',
    selected: true,
  },
  average_cpc: {
    label: 'CPC',
    name: 'average_cpc',
    type: 'currency',
    selected: true,
  },
  merchants_revenue: {
    label: 'Revenue',
    name: 'merchants_revenue',
    type: 'currency',
    selected: true,
  },
  mtd_spend: {
    label: 'MTD Spend',
    name: 'mtd_spend',
    type: 'currency',
    selected: true,
  },
};

const columns = {
  'merchant-overview': [
    base.short_name,
    base.merchants_revenue,
    base.average_roi,
    {
      label: 'Goal ROI',
      name: 'roi_goal',
      type: 'roi',
      selected: true,
    },
    base.average_cpc,
    base.clicks,
    {
      label: 'Spend',
      name: 'spend',
      type: 'currency',
      selected: true,
    },
    base.monthly_budget_amount,
    base.pacing_towards,
  ],
  'merch-ed-overview': [
    base.short_name,
    {
      label: 'Target ROI',
      name: 'target_roi',
      type: 'roi',
      selected: true,
    },
    {
      label: 'Actual ROI',
      name: 'reconciled_roi',
      type: 'roi',
      selected: true,
    },
    base.monthly_budget_amount,
    { ...base.pacing_towards, label: 'Spend Pacing' },
    base.mtd_spend,
    {
      label: 'Current Spend',
      name: 'spend',
      type: 'currency',
      selected: true,
    },
    {
      label: 'GMV',
      name: 'revenue',
      type: 'currency',
      selected: true,
    },
    {
      label: 'Take Rate',
      name: 'take_rate',
      type: 'percent',
      selected: true,
    },
    {
      label: 'Earnings',
      name: 'earnings',
      type: 'currency',
      selected: true,
    },
    base.clicks,
    { ...base.average_cpc, label: 'Avg CPC' },
  ],
  'publisher-overview': [
    {
      label: 'Publishers',
      name: 'full_name',
      type: 'string',
      selected: true,
    },
    {
      label: 'Publisher Revenue',
      name: 'publisher_revenue',
      type: 'currency',
      selected: true,
    },
    base.pacing_towards,
    base.average_cpc,
    {
      label: 'Impressions',
      name: 'impressions',
      selected: true,
    },
    base.clicks,
    {
      label: 'CTR',
      name: 'click_through_rate',
      type: 'percent',
      selected: true,
    },
    { ...base.merchants_revenue, label: 'Merchant Revenue' },
    base.average_roi,
  ],
};

const getColumns = statType => {
  return columns[statType];
};

const getStatCards = statType => {
  const cardsType = [
    'merchant-performance-overview',
    'campaign-center-campaigns-tab',
    'campaign-center-strategies-tab',
  ].includes(statType)
    ? 'spend-revenue-roi'
    : statType;
  return statCards[cardsType];
};

const statCards = {
  'merch-ed-overview': [
    {
      label: 'Total Retailer Spend',
      name: 'spend',
      type: 'currency',
    },
    {
      label: 'Narrativ Earnings',
      name: 'earnings',
      type: 'currency',
    },
    {
      label: 'Take Rate',
      name: 'take_rate',
      type: 'percent',
    },
    {
      label: 'GMV',
      name: 'revenue',
      type: 'currency',
    },
  ],
  'spend-revenue-roi': [
    {
      label: 'Spend',
      name: 'spend',
      type: 'currency',
    },
    {
      label: 'Revenue',
      name: 'revenue',
      type: 'currency',
    },
    {
      label: 'ROI',
      name: 'roas',
      type: 'roi',
    },
  ],
};

const getRowClasses = props => {
  /* Subrows should never be faded
   * Inactive main rows should be faded
   * If a row is expanded, other rows should be faded
   */
  const fadedText =
    'merchant_roi_goals' in props.data &&
    (props.data.is_active === false ||
      (props.expandedRowId !== null && props.expandedRowId !== props.data.merch_id));

  const heightened =
    props.budgetRowId && parseInt(props.budgetRowId.split(',')[0]) === props.data.merch_id;

  return {
    heightened,
    expanded: props.expandedRowId === props.data.merch_id,
    'faded-text': fadedText,
    sub: !('merchant_roi_goals' in props.data),
  };
};

const pacingIntervals = {
  '> 105%': {
    color: 'dark-green',
    icon: arrowGreenUpIcon,
    range: [1.05, null],
  },
  '90 - 105%': {
    color: 'light-green',
    icon: checkMarkIcon,
    range: [0.9, 1.05],
  },
  '75 - 90%': {
    color: 'orange',
    icon: arrowOrangeDownIcon,
    range: [0.75, 0.9],
  },
  '< 75%': {
    color: 'red',
    icon: arrowRedDownIcon,
    range: [null, 0.75],
  },
};

//	Need to find better var name, now being used for budget_pacing as well
const roiIntervals = {
  '> 105%': {
    color: 'orange',
    icon: arrowOrangeUpIcon,
    range: [1.05, null],
  },
  '95 - 105%': {
    color: 'dark-green',
    icon: checkMarkIcon,
    range: [0.95, 1.05],
  },
  '< 95%': {
    color: 'red',
    icon: arrowRedDownIcon,
    range: [null, 0.95],
  },
};

// TODO: Have backend send int/floats and frontend formats
const formatCurrencyStringToNumber = string => {
  if (string === '-') {
    return null;
  }
  return Number(string.replace(/[^0-9.-]+/g, ''));
};

const getIntervalColorAndIcon = (values, columnName) => {
  const [numerator, denominator] = values;
  const subject = denominator ? numerator / denominator : 0;

  let intervalObject;
  const intervalMap = columnName === 'pacing_towards' ? pacingIntervals : roiIntervals;
  const intervals = Object.keys(intervalMap);

  for (let i = 0; i < intervals.length; i++) {
    const interval = intervals[i];
    const currentIntervalObject = intervalMap[interval];
    const currentRange = currentIntervalObject.range;
    const min = currentRange[0] !== null ? currentRange[0] : Number.NEGATIVE_INFINITY;
    const max = currentRange[1] !== null ? currentRange[1] : Number.POSITIVE_INFINITY;

    if (subject >= min && subject < max) {
      intervalObject = currentIntervalObject;
      break;
    }
  }
  return intervalObject;
};

const getPacingIntervalOptions = () => {
  return Object.keys(pacingIntervals).map(interval => ({
    label: interval,
    selected: true,
    value: pacingIntervals[interval].range,
  }));
};

export {
  getColumns,
  getStatCards,
  getRowClasses,
  getIntervalColorAndIcon,
  getPacingIntervalOptions,
  formatCurrencyStringToNumber,
};
